module.exports = __webpack_public_path__ + "static/how-to-create-contest__step-1.2-11c995a7c3d2101d39e2e3fa9b276486.png";